// extracted by mini-css-extract-plugin
export default {"container":"Phone_container__Fz4q6","active":"Phone_active__K9Aa7"};